import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { IPackage } from "../../types/global";
import LocalPkgCard from "../cards/LocalPkgCard";
import NavBelt from "../page-essentials/NavBelt";
// import TestReponsive from "../page-essentials/TestReponsive";
import { localPkgBreadCrumpData } from "../static-data/breadcrump";
import PackagesService from "../../services/Packages.service";
import LangContext from "../../context/LangContext";

const LocalPackages = () => {
  const [data, setData] = useState<IPackage[]>([]);
  const [total, setTotal] = useState<number>();

  const [searchParams] = useSearchParams();
  const pkgCategory = searchParams.get("pkgCategory");

  const { lang_id } = useContext(LangContext);
  const fetchPackages = async (pkgCategory: string) => {
    try {
      const res = await PackagesService.fetchPackages(pkgCategory, lang_id);
      setData(res.data.data[0]);
      setTotal(res.data.data[1]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (pkgCategory && lang_id) {
      fetchPackages(pkgCategory);
    }
  }, [pkgCategory, lang_id]);

  return (
    <div>
      {/* <TestReponsive /> */}

      <NavBelt
        page="Local Packages"
        img="https://images.unsplash.com/photo-1623492701360-fb4a1205c789?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
        breadCrumpInfo={localPkgBreadCrumpData}
      />

      <div className="container mx-auto px-4 lg:px-8 2xl:px-12 my-8">
        <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:items-center md:justify-between">
          <h1 className="font-semibold text-2xl">
            {data[0]?.pkg_destination_category?.pkg_destination_category}
          </h1>
          <p>
            <span className="font-semibold">{total}</span> Total packages |{" "}
            <span className="text-primary-base">Nepal</span>
          </p>
        </div>
        <hr className="my-6" />

        {/* card section  */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8">
          {data.map((item, i) => (
            <LocalPkgCard data={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LocalPackages;
